export const Image = ({ id, value, updateValue, path, image, visible }) => {
  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      {image &&
        <img
          alt="..."
          src={image}
          style={{ width: '100%' }}
        />
      }
    </div>
  );
};
